import { isNil } from 'lodash';
import { queryParamHookFactory } from 'modules/taboola-common-frontend-modules/query-params';

const campaignGroupIdsDeserializer = campaignGroupIds => {
    if (isNil(campaignGroupIds)) {
        return [];
    }

    try {
        return JSON.parse(campaignGroupIds);
    } catch (e) {
        return [];
    }
};

export const BULK_EDIT_CAMPAIGNS_GROUP = 'bulkEditCampaignsGroup';

export const useBulkEditCampaignsGroupIds = queryParamHookFactory(BULK_EDIT_CAMPAIGNS_GROUP, {
    deserializer: campaignGroupIdsDeserializer,
    defaultValue: [],
});
